import { toDecimalString } from "../../../../../shared/utils/numbers";

const formaterNumberCell = (value,precision) => value < 0 ? `(${toDecimalString(value*-1,precision)})` : (value>0 ? toDecimalString(value,precision) : '-');
const mayorCien = (value) => value > 0 ? '>100' : '(>100)';

export const subTitlesTableRealObj = (año) => [
    {label:`REAL ${año-2}-12`, colIni:0, colFin:7},
    {label:'', colIni:8, colFin:10},
    {label:`REAL  ${año-1}-12`, colIni:11, colFin:31}
]

export const columnsTableRealObj = (año) => [
    {
        field: 'tRealAnt_CONT',
        name: 'CONT',
        sortable: false,
        'data-test-subj': 'firstNameCell',
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.tRealAnt_CONT,0)}</span>),
        width:'110px'
    },
    {
        field: 'tRealAnt_FACT',
        name: 'FACT',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.tRealAnt_FACT,0)}</span>),
        width:'110px'
    },
    {
        field: 'tRealAnt_PROD',
        name: 'PROD',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.tRealAnt_PROD,0)}</span>),
        width:'110px'
    },
    {
        field: 'tRealAnt_APOR',
        name: 'APOR',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.tRealAnt_APOR,0)}</span>),
        width:'110px'
    },
    {
        field: 'tRealAnt_Margen',
        name: '%MARGEN',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.tRealAnt_Margen)>100 ? mayorCien(data.tRealAnt_Margen) : formaterNumberCell(data.tRealAnt_Margen,1)}</span>),
        width:'100px'
    },
    {
        field: 'tRealAnt_BDI',
        name: 'BDI',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.tRealAnt_BDI,0)}</span>),
        width:'110px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'5px'
    },
    {
        field: 'tRealAnt_CARTTOTAL',
        name: 'CART TOTAL',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.tRealAnt_CARTTOTAL,0)}</span>),
        width:'110px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'10px'
    },
    {
        name: 'Centro',
        'data-test-subj': 'centro',
        sortable: true,
        render: (data) =>(
            <span>{ ((data.idPais!=='@@' && data.idPais!=='A@') ? (data.idPais==='00' ? `NACIONAL` : `INTERNACIONAL`) : `${data.idCentro} - ${data.centro}`)}</span>
        ),
        width:'400px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'10px'
    },
    {
        field: 'cont',
        name: 'CONT',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.cont,0)}</span>),
        width:'110px'
    },
    {
        field: 'conT_REAL_OBJ',
        name: 'IP CONTs/OBJ',
        sortable: false,
        dataType: 'number',
        'data-test-subj': 'IPCell',
        render: (data) => (<span>{Math.abs(data.conT_REAL_OBJ)>100 ? mayorCien(data.conT_REAL_OBJ) : formaterNumberCell(data.conT_REAL_OBJ,2)}</span>),
        width:'90px'
    },
    {
        field: 'conT_REAL_REALANT',
        name: `Δ s/${año-2} CONT (%)`,
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.conT_REAL_REALANT)>100 ? mayorCien(data.conT_REAL_REALANT) : formaterNumberCell(data.conT_REAL_REALANT,1)}</span>),
        width:'100px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'5px'
    },
    {
        field: 'fact',
        name: 'FACT',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.fact,0)}</span>),
        width:'110px'
    },
    {
        field: 'facT_REAL_OBJ',
        name: 'IP FACTs/OBJ',
        sortable: false,
        dataType: 'number',
        'data-test-subj': 'IPCell',
        render: (data) => (<span>{Math.abs(data.facT_REAL_OBJ)>100 ? mayorCien(data.facT_REAL_OBJ) : formaterNumberCell(data.facT_REAL_OBJ,2)}</span>),
        width:'90px'
    },
    {
        field: 'facT_REAL_REALANT',
        name: `Δ s/${año-2} FACT (%)`,
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.facT_REAL_REALANT)>100 ? mayorCien(data.facT_REAL_REALANT) : formaterNumberCell(data.facT_REAL_REALANT,1)}</span>),
        width:'100px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'5px'
    },
    {
        field: 'prod',
        name: 'PROD',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.prod,0)}</span>),
        width:'110px'
    },
    {
        field: 'proD_REAL_OBJ',
        name: 'IP PRODs/OBJ',
        sortable: false,
        dataType: 'number',
        'data-test-subj': 'IPCell',
        render: (data) => (<span>{Math.abs(data.proD_REAL_OBJ)>100 ? mayorCien(data.proD_REAL_OBJ) : formaterNumberCell(data.proD_REAL_OBJ,2)}</span>),
        width:'90px'
    },
    {
        field: 'proD_REAL_REALANT',
        name: `Δ s/${año-2} PROD (%)`,
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.proD_REAL_REALANT)>100 ? mayorCien(data.proD_REAL_REALANT) : formaterNumberCell(data.proD_REAL_REALANT,1)}</span>),
        width:'100px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'5px'
    },
    {
        field: 'apor',
        name: 'APOR',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.apor,0)}</span>),
        width:'110px'
    },
    {
        field: 'apoR_REAL_OBJ',
        name: 'IP APORs/OBJ',
        sortable: false,
        dataType: 'number',
        'data-test-subj': 'IPCell',
        render: (data) => (<span>{Math.abs(data.apoR_REAL_OBJ)>100 ? mayorCien(data.apoR_REAL_OBJ) : formaterNumberCell(data.apoR_REAL_OBJ,2)}</span>),
        width:'90px'
    },
    {
        field: 'apoR_REAL_REALANT',
        name: `Δ s/${año-2} APOR (%)`,
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.apoR_REAL_REALANT)>100 ? mayorCien(data.apoR_REAL_REALANT) : formaterNumberCell(data.apoR_REAL_REALANT,1)}</span>),
        width:'100px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'5px'
    },
    {
        field: 'margen',
        name: '%MARGEN',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.margen,1)}</span>),
        width:'100px'
    },
    // {
    //     field: 'margen_DIF',
    //     name: `Δ s/${año-1} %MARGEN (DIF.)`,
    //     sortable: false,
    //     dataType: 'number',
    //     render: (data) => (<span>{Math.abs(data.margen_DIF)>100 ? '>100' : formaterNumberCell(data.margen_DIF,1)}</span>),
    //     width:'100px'
    // },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'5px'
    },
    {
        field: 'bdi',
        name: 'BDI',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.bdi,0)}</span>),
        width:'110px'
    },
    {
        field: 'bdI_REAL_OBJ',
        name: 'IP BDIs/OBJ',
        sortable: false,
        dataType: 'number',
        'data-test-subj': 'IPCell',
        render: (data) => (<span>{Math.abs(data.bdI_REAL_OBJ)>100 ? mayorCien(data.bdI_REAL_OBJ) : formaterNumberCell(data.bdI_REAL_OBJ,2)}</span>),
        width:'90px'
    },
    {
        field: 'bdI_REAL_REALANT',
        name: `Δ s/${año-2} BDI (%)`,
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.bdI_REAL_REALANT)>100 ? mayorCien(data.bdI_REAL_REALANT) : formaterNumberCell(data.bdI_REAL_REALANT,1)}</span>),
        width:'100px'
    },
    {
        field: 'tipO_MED_IMP',
        name: 'Tipo Medio Impositivo',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.tipO_MED_IMP)>100 ? mayorCien(data.tipO_MED_IMP) : formaterNumberCell(data.tipO_MED_IMP,1)}</span>),
        width:'100px'
    },
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'5px'
    },

    {
        field: 'carttotal',
        name: 'CART TOTAL',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.carttotal,0)}</span>),
        width:'110px'
    },
    {
        field: 'carttotaL_REAL_REALANT',
        name: `Δ s/${año-2} CART (%)`,
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.carttotaL_REAL_REALANT)>100 ? mayorCien(data.carttotaL_REAL_REALANT) : formaterNumberCell(data.carttotaL_REAL_REALANT,1)}</span>),
        width:'100px'
    }
  ];